import { configureStore } from "@reduxjs/toolkit"
import APISlice from "./slices/APISlice"
import APIResponseSlice from "./slices/APIResponseSlice"

export const store = configureStore({
  reducer: {
    // MSALAuth: APISlice,
    APIResponse: APIResponseSlice,
  },
})